import * as svg from "../../../assets/paper-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const PaperIcon = iconBuilder(svg, "PaperIcon", "0 0 8 8");
